import { nextjsPlugin } from '@datadog/browser-rum-nextjs'
import { initDatadogRum } from './utils/datadog'

initDatadogRum({ plugins: [nextjsPlugin()] })
